@if (isShow) {
<div class="d-lg-flex mt-4 {{class}}">
  <app-btn text="Edit" routerLink="../edit" icon="edit" [queryParamsHandling]="'merge'" type="secondary"></app-btn>
  <span class="mx-1"></span>
  <app-btn text="Clone" routerLink="../clone" icon="clone" [queryParamsHandling]="'merge'" type="secondary">
  </app-btn>
</div>
}
